import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export type AssignableUserDto = {
  userId: string;
  displayName: string;
  email: string;
};

@Injectable({ providedIn: 'root' })
export class UsersApiService {
  constructor(private readonly http: HttpClient) {}

  getAssignableUsers(): Observable<AssignableUserDto[]> {
    return this.http.get<AssignableUserDto[]>('/api/users/assignable');
  }
}
